const twIframeCustomize = () => {
	const twItems = document.querySelectorAll('.twitterPost__link');
	const resize = (el) => {
		const parent = el.querySelector('.twitter-tweet');
		if (!parent) {
			return;
		}
		const iframe = el.querySelector('iframe');
		if (iframe) {
			const check = setInterval(() => {
				if (iframe.clientWidth > 0) {
					iframe.style.maxHeight = '';
					const ratio = el.clientWidth / iframe.clientWidth;
					const antiRatio = iframe.clientWidth / el.clientWidth;
					const iframeStyle = getComputedStyle(iframe);
					const iframeHeight = parseFloat(iframeStyle.getPropertyValue('max-height').replace('px', ''));
					iframe.style.maxHeight = (iframeHeight * antiRatio) + 'px';
					parent.style.transform = 'scale(' + ratio + ')';
					parent.classList.add('show');
					clearInterval(check);
					return;
				}
			}, 100);
		}
		return false;
	};
	twItems.forEach((el) => {
		if (resize(el)) {
			return true;
		}
		const cb = (mutationsList, observer) => {
			resize(mutationsList[0].target);
			observer.disconnect();
		};
		const twObserver = new MutationObserver(cb);
		twObserver.observe(el, {
			attributes: true,
			childList: true,
			characterData: true
		});
	});
};

window.addEventListener('load', twIframeCustomize);
window.addEventListener('resize', twIframeCustomize);